import React, { useState, useEffect } from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import FormMultiplier from '../../../../Components/Form/FormMultiplier';
import FormControl from '../../../../Components/Form/FormControl';
import FormMultiplierRemoveButton from '../../../../Components/Form/FormMultiplierRemoveButton';
import RemoveButton from '../../../../Components/Button/RemoveButton';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import WorkplaceMedicalProceduresSelect from '../../../../Components/Base/WorkplaceMedicalProcedures/WorkplaceMedicalProceduresSelect';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import useMedicalReportValidation from '../../../MedicalReport/Hooks/useMedicalProcedureValidation';
import { SelectValue } from '../../../../Components/Base/Select/Select';

interface Props {
	defaultData: CareClaimDefaultFormValues;
	onSubmit: (values: CareClaimDefaultFormValues) => Promise<void>;
	isLoading: boolean;
}

export interface ExtendedSelectValue extends SelectValue {
	exists?: boolean;
	careClaimId?: string;
}

export interface CareClaimDefaultFormValues {
	medicalProcedures: Array<{ medicalProcedure: ExtendedSelectValue }>;
}

const DiscourseCareClaimForm = ({
	defaultData,
	onSubmit,
	isLoading,
}: Props) => {
	const { validationSchema } = useMedicalReportValidation();

	const handleSave = async (values: any) => {
		await onSubmit(values as CareClaimDefaultFormValues);
	};

	const formMethods = useForm({
		defaultValues: defaultData,
		resolver: yupResolver(validationSchema),
	});

	useEffect(() => {
		formMethods.reset(defaultData);
	}, [defaultData, formMethods]);

	return (
		<FormWrapper formMethods={formMethods}>
			<FormMultiplier
				name='medicalProcedures'
				addButtonTitle='base.addAnother'
				createDefault={0}>
				{({ itemsCount }) => (
					<>
						<FormControl
							label='component.discourse.medicalProcedure'
							name='medicalProcedure'
							isRequired>
							<WorkplaceMedicalProceduresSelect />
						</FormControl>
						{itemsCount > 0 && (
							<FormMultiplierRemoveButton>
								<RemoveButton
									onClick={() => void 0}
									title='base.shared.remove'
								/>
							</FormMultiplierRemoveButton>
						)}
					</>
				)}
			</FormMultiplier>
			<SubmitButton
				title='base.shared.save'
				onSubmit={handleSave}
				disabled={isLoading}
			/>
		</FormWrapper>
	);
};

export default DiscourseCareClaimForm;
